import axios from 'axios'

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: '/api/v1',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Include cookies in requests
})

// Request interceptor - add auth token from cookie if available
apiClient.interceptors.request.use(
  (config) => {
    // Token is handled via HttpOnly cookie, no need to add header manually
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor - handle common errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Redirect to login for unauthenticated users
      // Exception: Don't redirect if already on a public auth page to avoid redirect loops
      const currentPath = window.location.pathname

      // Public auth pages that don't require authentication
      // NOTE: When adding new public/auth pages, add them here to prevent redirect loops
      const publicAuthPaths = [
        '/login',
        '/signup',
        '/forgot-password',
        '/reset-password',
        '/activate_account',
        '/activation-pending',
        '/extension-auth',
      ]

      if (!publicAuthPaths.includes(currentPath)) {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

export default apiClient
